var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-home"},[_c('div',{ref:"katex"},[_vm._v("题目如下$\\frac{x^{2}}{9}+\\frac{y^{2}}{6}=1$")])])
}
var staticRenderFns = []

export { render, staticRenderFns }